import React, { useEffect } from 'react';
import { DatePicker } from './DatePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
export const SingleDate = ({ dataQa, disableFuture, filterDates, isDateBefore, isMobile, labels: { inputFormat, labelDate }, maxDate, minDate, onChangeSingleDate, setIsSingleDateInvalid, onReset }) => {
    useEffect(() => {
        const dateToTest = isDateBefore ? filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore : filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter;
        if (dateToTest) {
            if (setIsSingleDateInvalid) {
                if (dayjs(dateToTest).isValid())
                    setIsSingleDateInvalid(false);
                else
                    setIsSingleDateInvalid(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterDates, isDateBefore]);
    return (React.createElement(DatePicker, { isMobile: isMobile, onChange: (value) => onChangeSingleDate(isDateBefore, value), disableFuture: disableFuture || false, maxDate: maxDate || null, minDate: minDate || null, value: filterDates ? (isDateBefore ? dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore) : dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter)) : null, inputFormat: inputFormat, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { "data-qa": `${dataQa}-datePicker`, label: labelDate, inputFormat: inputFormat }))), OpenPickerButtonProps: {
            id: `${dataQa}-datePickerIcon`,
        }, toolbarTitle: '', onReset: onReset }));
};
